import apiService from "./apiService";
import AppConstants from "../appConstants";

class SubscribeService {
    getAllSubscribe(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SUBSCRIBER_GETALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_SUBSCRIBER_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================
}

export default new SubscribeService();
